export default __webpack_public_path__ + "static/media/ActiveWindowIcon.eefe0c08.svg";